export default {
  header: {
    title: 'Rewards',
  },
  content: {
    title: 'You have {{balance}} points',
    description: 'Spend {{amount}}, get {{rewards}} points! Add free items to your cart with your earned points.',
    articles: {
      title: 'Earn points with every order',
      spend_description: 'Every {{amount}} you spend adds {{rewards}} points to your account.',
      redeem_description:
        'Redeem your points for free treats! Start earning rewards at {{minSpendingLimit}} points, equivalent to {{amount}} spent',
      discounts_description: 'Unlock exclusive deals, offers, and discounts. Watch the app for member-only promotions.',
    },
  },
};
